import type { IEventLocation } from '@api/EventSlotsApi';

export function formatEventLocation(eventLocation: IEventLocation): string {
	const {
		address: { street, street_number, postal_code, city }
	} = eventLocation;

	return `${street} ${street_number}, ${postal_code} ${city}`;
}
